<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>发票</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>全部运单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">发货地</span>
        <el-input
          v-model.trim="filter.specifiedLoadPlace"
          style="width: 140px"
          placeholder="请输入发货地址"
          :maxlength="addressKeywordLimit"
          clearable
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">卸货地</span>
        <el-input
          v-model.trim="filter.specifiedUnloadPlace"
          style="width: 140px"
          placeholder="请输入卸货地址"
          :maxlength="addressKeywordLimit"
          clearable
        ></el-input>
      </div>
      <div class="toolbar-item" id="auto-6">
        <span class="demonstration">时间段</span>
        <el-select class="short" v-model="filter.queryTimeType" placeholder="请选择">
          <el-option v-for="item in selectOption" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filter.queryTimeStart"
          type="datetime"
          style="width: 200px"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <el-date-picker
          v-model="filter.queryTimeEnd"
          type="datetime"
          style="width: 200px"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="demonstration">发票状态</span>
        <el-select v-model="filter.examineState" placeholder="请选择" class="normal">
          <el-option v-for="item in orderStatusArr" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <CarrierCompany
        ref="CarrierCompany"
        @changeValue="changeItem('carrierCompanyCode', ...arguments)"
      ></CarrierCompany>
      <div class="toolbar-item" id="auto-4">
        <span class="demonstration">运价</span>
        <el-select class="short" v-model="filter.unitPriceType" placeholder="请选择">
          <el-option v-for="item in priceOption" :label="item.label" :value="item.value" :key="item.value"> </el-option>
        </el-select>
        <el-input v-model.trim="filter.unitPriceMin" :maxlength="20" placeholder="保留两位小数"></el-input>
        <span>-</span>
        <el-input v-model.trim="filter.unitPriceMax" :maxlength="20" placeholder="保留两位小数"></el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <el-popover
          ref="popover1"
          placement="top-start"
          width="300"
          trigger="focus"
          content="搜索货源备注，发货单号，车牌号，运单号，货物类型，收单员备注，收货单据号"
        >
        </el-popover>
        <span class="demonstration">其他</span>
        <el-input
          v-model.trim="filter.searchKey"
          v-popover:popover1
          class="long"
          :maxlength="ordernumberKeywordLimit"
          placeholder="输入货源备注，发货单号，车牌号，运单号，货物类型，收单员备注，收货单据号"
        ></el-input>
      </div>

      <Intermediary ref="Intermediary" @changeValue="changeItem('intermediary', ...arguments)"></Intermediary>
      <div class="toolbar-item" id="auto-11">
        <span class="demonstration">增值服务</span>
        <el-select v-model="filter.appendServiceType" placeholder="请选择">
          <el-option v-for="item in appendServiceTypeArr" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item">
        <el-button class="custom-search-btn" @click="screenList" id="auto-7">筛选</el-button>
        <el-button class="custom-reset-btn" size="small" @click="resetSearch" id="auto-8">重置</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 全部运单列表 </span>
      </div>
      <div class="fr" id="auto-9">
        <el-input
          @click.native="handleShowMore"
          :readonly="true"
          v-model="batchSearchValShow"
          placeholder="批量搜索车牌、司机、手机号、运单号、客户单号"
          class="batch-search-input mr-15"
          :title="batchSearchValShow"
        >
          <i slot="suffix" class="batch-search-ic"></i>
        </el-input>
        <el-button type="primary" size="small" @click="exportList" id="auto-7">导出表格</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-10">
      <el-table :data="tableData.data" border :max-height="tableMaxHeight">
        <el-table-column width="40" type="expand">
          <template v-slot="scope">
            <el-form label-position="left" inline class="self-table-expand">
              <el-form-item label="货物类型">
                <span :title="scope.row.stockCategoryName">{{ scope.row.stockCategoryName }}</span>
              </el-form-item>
              <el-form-item label="经纪人">
                <span>{{ scope.row.agentName }}</span>
              </el-form-item>
              <el-form-item label="发货单号">
                <span :title="scope.row.stockOrder">{{ scope.row.stockOrder }}</span>
              </el-form-item>
              <el-form-item label="收货单据号">
                <span :title="scope.row.settlementNum">{{ scope.row.settlementNum }}</span>
              </el-form-item>
              <el-form-item label="货源备注">
                <span :title="scope.row.stockDesc">{{ scope.row.stockDesc }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ scope.row.vehicleNumber }}</span>
              </el-form-item>
              <el-form-item label="客户单号">
                <span :title="scope.row.customerOrderNos && scope.row.customerOrderNos.join(',')">{{
                  scope.row.customerOrderNos && scope.row.customerOrderNos.join(',')
                }}</span>
              </el-form-item>
              <el-form-item label="收单员备注">
                <span :title="scope.row.receiverRemark">{{ scope.row.receiverRemark }}</span>
              </el-form-item>
              <el-form-item label="下单日期">
                <span>{{ scope.row.orderCreateTime | stamp2TextDateFull }}</span>
              </el-form-item>
              <el-form-item label="退款时间">
                <span>{{ scope.row.offlineRefundTime | stamp2TextDateFull }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="运单号" width="160">
          <template v-slot="scope">
            <span class="font-blue pointer" @click="showDetail(scope.row)">{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStateDesc" label="运单状态" width="140"> </el-table-column>
        <el-table-column prop="refundStateDesc" label="退款状态" width="140"> </el-table-column>
        <el-table-column prop="stockStatusDesc" label="运费开票" width="100"> </el-table-column>
        <el-table-column prop="stockFeeStatusDesc" label="调度费开票" width="100"> </el-table-column>
        <el-table-column prop="stockPlatformFeeStatusDesc" label="服务费开票" width="100"> </el-table-column>
        <el-table-column prop="cargoGuaranteeStatusDesc" label="货保服务费开票" width="120"> </el-table-column>
        <el-table-column prop="haulageName" label="承运公司" width="120" class-name="pointer" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="specifiedLoadPlace" label="装货地" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="specifiedUnloadPlace" label="卸货地" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="mileage" label="运输里程(公里)" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="vehicleNumber" label="车牌号" width="100"> </el-table-column>

        <el-table-column label="下单运价(元/吨)" width="120" class-name="pointer">
          <template v-slot="scope">
            <span>{{ scope.row.originUnitPrice | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收单运价(元/吨)" width="120" class-name="pointer">
          <template v-slot="scope">
            <span>{{ scope.row.actualUnitPrice | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实发数量(吨)" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.originalUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收数量(吨)" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.actualUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运费(元)" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.freightAmt | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="调度费(元)" width="120" class-name="pointer">
          <template v-slot="scope">
            <span>{{ scope.row.carryServiceAmt | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费(元)" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.platformServiceAmt | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label=" 货保服务费（元）" width="130">
          <template v-slot="scope">
            <span>{{ scope.row.cargoGuaranteePrice | thousands(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="billtotalmoney" label="合计(元)" width="110">
          <template v-slot="scope">
            <span>{{ scope.row.feeTotalAmt | thousands(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="完结时间" width="140">
          <template v-slot="scope">{{ scope.row.payTime | stamp2TextDateFull }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        :page-sizes="[10, 20, 50, 100, 200]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total,sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="提示" :close-on-click-modal="false" custom-class="dia-tiny">
      <div class="text-c font-size16 mb-5">是否确认导出以下时段的查询结果？</div>
      <div class="text-c font-size14">
        开始时间：
        <span class="font-orange">{{ startTime }}</span>
      </div>
      <div class="text-c font-size14">
        结束时间：
        <span class="font-orange">{{ endTime }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirm">确 定</el-button>
      </span>
    </el-dialog>

    <batch-search ref="batchSearch" @bacthCallBack="bacthCallBack"></batch-search>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:11
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/wallet.new.api';
import { WUYI } from '@/api/common';
import dateLimit from '@/api/dateLimit';
import { batchSearchFilter, completeDate } from '@/utils';
import Intermediary from '@/components/Intermediary.vue';
import CarrierCompany from '@/components/CarrierCompany.vue';
import BatchSearch from '@/components/BatchSearch';
export default {
  name: 'AllOrderList',
  components: { Intermediary, CarrierCompany, BatchSearch },
  data() {
    return {
      tableMaxHeight: WUYI.tableMaxHeight,
      batchSearchLimit: WUYI.batchSearchLimit,
      pageSize: 20,
      currentPage: 1, //当前分页
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      orderStatusArr: [
        { label: '全部', value: 0 },
        { label: '审核中', value: 1 },
        { label: '开票', value: 2 },
        { label: '不可开票', value: 3 }
      ],
      filter: {
        specifiedLoadPlace: '', //装货地
        specifiedUnloadPlace: '', //卸货地
        searchKey: '', // 筛选条件
        examineState: 0, // 状态查询
        intermediary: '', // 中介编码
        unitPriceType: 1, // 下单运价/收单运价
        unitPriceMin: '', // 运价范围，起始值
        unitPriceMax: '', // 运价范围，截止值
        batchType: 0, // 批量搜索类型
        batchValues: [], // 批量搜索值
        queryTimeType: 1, //完结时间/接单时间
        queryTimeStart: new Date(dateLimit.getThreeMonth()).getTime(), //完结时间/接单时间，起始值
        queryTimeEnd: dateLimit.currentDayEnd.getTime(), // 完结时间/接单时间，截止值
        carrierCompanyCode: '',
        appendServiceType: null
      },
      cache: {},
      tableData: { total: 0, data: [] },
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      selectOption: [
        { label: '完结时间', value: 1 },
        { label: '付款时间', value: 5 },
        { label: '接单时间', value: 2 }
      ],
      priceOption: [
        { label: '下单运价', value: 1 },
        { label: '收单运价', value: 2 }
      ],
      batchSearchTypeList: [
        { val: 1, name: '车牌' },
        { val: 2, name: '司机手机' },
        { val: 3, name: '司机姓名' },
        { val: 4, name: '运单号' },
        { val: 5, name: '客户单号' }
      ],
      batchSearchValShow: '',
      dialogVisible: false,
      appendServiceTypeArr: []
    };
  },
  computed: {
    startTime() {
      const startTime = this.cache.queryTimeStart;
      if (startTime) {
        if (typeof startTime == 'number') {
          return WUYI.timeFormat(startTime) + ' ' + WUYI.formatDate(startTime);
        } else {
          return startTime;
        }
      } else {
        return '';
      }
    },
    endTime() {
      const endTime = this.cache.queryTimeEnd;
      if (endTime) {
        if (typeof endTime == 'number') {
          return WUYI.timeFormat(endTime) + ' ' + WUYI.formatDate(endTime);
        } else {
          return endTime;
        }
      } else {
        return '';
      }
    }
  },
  created() {
    this.getDict();
  },
  methods: {
    getDict() {
      axios.post(api.bamsDict, { dictType: 'company_added_services' }).then(res => {
        this.appendServiceTypeArr = res.data;
      });
    },
    //筛选查询
    screenList() {
      if (this.filter.queryTimeStart > this.filter.queryTimeEnd) {
        this.$message.warning('开始时间不可大于结束时间');
        return;
      }
      if (!completeDate(new Date(this.filter.queryTimeStart), new Date(this.filter.queryTimeEnd), 12)) {
        this.$message.error('跨月选择最大时间区域为12个月');
        return;
      }
      // 校验价格区间
      if (!WUYI.checkSelectPrice(this.filter.unitPriceMin, this.filter.unitPriceMax)) return;
      this.cache = { ...this.filter };
      this.currentPage = 1;
      this.ajaxRequest();
    },
    showDetail(row) {
      window.open(`./orderdetail.html#/${row.orderNumber}`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.ajaxRequest();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.screenList();
    },
    ajaxRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.cache
      };
      axios.post(api.qryWholeOrderList, options).then(res => {
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total || 0;
      });
    },
    resetSearch() {
      this.filter.specifiedLoadPlace = '';
      this.filter.specifiedUnloadPlace = '';
      this.filter.searchKey = '';
      this.filter.examineState = 0;
      this.filter.intermediary = '';
      this.filter.unitPriceType = 1;
      this.filter.unitPriceMin = '';
      this.filter.unitPriceMax = '';
      this.filter.batchType = 0;
      this.filter.batchValues = [];
      this.filter.queryTimeType = 1;
      this.filter.queryTimeStart = new Date(dateLimit.getThreeMonth()).getTime();
      this.filter.queryTimeEnd = dateLimit.currentDayEnd.getTime();
      this.batchSearchValShow = '';
      this.$refs.Intermediary.intermediary = '';
      this.filter.carrierCompanyCode = '';
      this.$refs.CarrierCompany.carrierCompanyCode = '';
      this.filter.appendServiceType = null;
    },
    handleShowMore() {
      this.$refs.batchSearch.openDia();
    },
    bacthCallBack(data) {
      const { batchType, batchValues, batchSearchValShow } = data;
      this.batchSearchValShow = batchSearchValShow;
      this.filter.batchType = batchType;
      this.filter.batchValues = batchSearchFilter(batchValues);
      this.screenList();
    },
    //导出
    exportList() {
      if (this.tableData.total == 0) {
        this.$message.warning('未查询到数据，请重新筛选');
        return;
      }
      this.dialogVisible = true;
    },
    comfirm() {
      const exportData = { ...this.cache };
      axios.post(api.exportWholeOrderList, exportData).then(res => {
        this.dialogVisible = false;
        this.$message.success('提交成功，请稍后在“下载管理”中查看');
      });
    },
    changeItem(key, val) {
      this.filter[key] = val;
    }
  }
};
</script>
<style>
.batchSearch-custom-dialog {
  width: 536px;
}
.batch-search-icon {
  display: block;
  background: url('../../assets/img/wallet/ico_sdfh_gd@2x.png') no-repeat;
  width: 17px !important;
  height: 15px !important;
  background-size: 17px 15px !important;
  margin-top: 10px;
  cursor: pointer;
}
</style>
